import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDashAuth } from "./AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ adminOnly = false }) => {
  const { user, loading } = useDashAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/dashboard/login" replace state={{ from: location.pathname }} />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
};
